import { VehicleDriverSideIcon } from '@THC/components/Icons/VehicleDriverSide';
import { MDText } from 'i18n-react';

import LocalTexts from './NoImage.text.json';

import styles from './NoImage.module.scss';

const LocalT = new MDText(LocalTexts);

export const NoImage: React.FC = () => {
	return (
		<div className={styles.error}>
			<VehicleDriverSideIcon />
			<div className={styles.text}>{LocalT.translate('text')}</div>
		</div>
	);
};
